import React, { Component } from "react";
import { UserContext } from "../auth/providers";
//#region package Import
import swal from "sweetalert";
import ReactPlayer from "react-player";
import arrow from "../auth/login/arrow.svg";
import Button from "@material-ui/core/Button";
import coinSound from "./coins.wav";
import { BiVolumeMute } from "react-icons/bi";
import { GoUnmute } from "react-icons/go";
import { AiOutlineArrowDown } from "react-icons/ai";
//#endregion
import add from "./add.svg";
import selected from "./selected.svg";
import right__wing from "./right-wing.svg";
import bottom__wing from "./bottom-wing.svg";
//#region importing components
import Menu from "./Menu/Menu";
import MyProfile from "./MyProfile/MyProfile";
import Scene from "../common/Scene/Scene";
import QNA from "../Qna/App1";
import PublicPoll from "../Poll/PublicPoll";
import spinner from "./spinner.svg";
import delete__icon from "./delete.svg";
import cut from "./cut.svg";
import igFilter from "./igFilter.jpg";
import igGame from "./igGame.jpg";

//#endregion

//#region Const import
import {
  AnalyticsLocations,
  gameScores,
  HotspotType,
  StaticLinks,
} from "../../const/fixed/Types";
import {
  AudiData,
  DBRData,
  LabData,
  LobbyHotspots,
  LobbyHotspotsId,
  TeamsData,
} from "../../data/Lobby/hotspots";
import {
  SubMenuId,
  menuItems,
  menuItemsId,
  menuItemsIndex,
  NetworkingSubmenuId,
  DBRSubMenuIndex,
} from "../../const/Menu/MenuConst";
import { VideoString } from "../../const/assets/VideoString";
import { ImageString } from "../../const/assets/ImageString";
import VideoPlayer from "../common/videoPlayer/VideoPlayer";
import {
  firestore,
  updateUserLocation,
  addRealtimeHotspotAnalytics,
  checkForDailycoAdmin,
  getDailycoRoomDetails,
  checkDailycoRoomStatus,
  getAvailableTwilioVideoCallRoom,
  clearTwilioVideoCallRoom,
  addCustomRealtimeHotspotAnalytics,
  getLinkListener,
  removeLinkListener,
  signOut,
  storage,
  firebaseApp,
} from "../firebase/firebase";
import LobbyTut from "./Tut/LobbyTut";
import ReactAudioPlayer from "react-audio-player";
import CustomNotification from "../common/CustomNotification/CustomNotification";
import ClientChat from "../client-chat/ClientChat";
import PdfPlayer from "../common/PdfPlayer/PdfPlayer";
import { AppString } from "../firebase/AppString";
import { VideoPlayerData } from "../../data/Lobby/realtimeData";
import { isIOS, isIPad13, isMobileSafari } from "react-device-detect";
import ScoreCard from "../scorecard/ScoreCard";
import Game from "../Game/Game";
import MemoryLane from "../MemoryLane/MemoryLane";
//#endregion
const videoRatios = 2.33;

class Home2 extends Component {
  state = {
    playCurrentAudio: true,
    gotoZoomLink: "",
    showGotoZoom: false,
    instructionVideo: false,
    instructionVideoLink: "",
    startGameScreen: true,
    endGameScreen: false,
    alreadyCollected: false,
    myScore: 0,
    showMemoryLane: false,
    playedCount: 0,
    introVideoMuted: false,
    isLinkLoaded: false,
    mute: false,
    funzone: true,
    funzoneLnk:
      "https://storage.googleapis.com/sephora-da876.appspot.com/Intro.mp4",
    showIntro: true,
    introLink:
      "https://storage.googleapis.com/sephora-da876.appspot.com/funzone-1.mp4",
    showRotate: true,
    showClosedPopup: false,
    restrictedZones: {},
    loading: false,
    overlayImages: [],
    showOverlayPopup: false,
    showLiveIframe: false,
    gamePoints: [],
    gameLeaderBoard: [],
    UI: {
      menuItems: menuItems,
      activeMenu: menuItems[menuItemsIndex.Prelobby],
      activeSubMenu: null,
      lastMenu: menuItems[0],
      overlayMenu: null,
      MenuVisible: true,
      isInteractable: true,
      showMediaModal: false,
      clicked: false,
      showHelpdeskChat: false,
      showLeaderboard: false,
      showLeaderboardButton: true,

      showSurveyPopup: false,
      surveyDetails: null,

      showDBRSidePanel: true,

      showStallChat: false,

      showGlobalChat: true,
      hideGlobalChat: true,
    },
    HelpdeskChat: {
      showChat: true,
      showButton: false,
    },
    MediaModalInfo: {
      link: "",
      type: null,
    },
    DBRVideoCall: {
      roomOptions: { t1: { publicRoomName: "team3" } },
      room: null,
      showVideoCall: false,
      roomAdmin: null,
    },
    TwilioVideoCall: {
      slot: null,
      room: null,
      showVideoCall: false,
    },
    stallChat: {
      id: "",
    },
    audiLnk: AudiData.link,
    lablink: LabData.link,
    zoomlink: DBRData.zoomlink,
    rmtpURL: AudiData.rmtpURL,
    showImage: AudiData.showImage,
    imageLink: AudiData.imageLink,
    streamLink: AudiData.streamLink,
    infolink: "/assets/content/sample.pdf",
    pressroom: "/assets/content/sample.pdf",
    gamezone: "/assets/content/sample.pdf",
    faceyoga: "/assets/content/sample.pdf",
    igfilter: "/assets/content/sample.pdf",
  };
  currentOverlayCallback = null;
  currentAudioRef = React.createRef();
  AudioListenerRemoved = false;
  coinsound = React.createRef();
  anyFunction = (area) => {
    // console.log(area);
    if (area) {
      if (area !== "treasurehunt") this.addHotspotAnalytics(area);
    }
    switch (area) {
      case "memorylane":
        this.setState({ showMemoryLane: true });
        break;
      case "iggamer":
        false
          ? this.showMediaModal(
            HotspotType.anchor,
            "https://www.instagram.com/ar/1174017956344497"
          )
          : this.showMediaModal(HotspotType.ImgGrapics, {
            for: "igGame",
            bg: igGame,
          });
        if (window.parent.mute) window.parent.mute();
        break;
      case "treasurehunt":
        this.handleClick(null, menuItems[menuItemsIndex.Game]);
        break;
      case "infodesk":
        this.showMediaModal(HotspotType.pdf, this.state.infolink);
        if (window.parent.mute) window.parent.mute();
        break;
      case "igfilter":
        false
          ? this.showMediaModal(
            HotspotType.anchor,
            "https://www.instagram.com/ar/1174017956344497"
          )
          : this.showMediaModal(HotspotType.ImgGrapics, {
            for: "igFilter",
            bg: igFilter,
          });
        if (window.parent.mute) window.parent.mute();
        break;
      default:
        console.log(area);
        break;
    }
  };
  forcePush = () => {
    firestore
      .collection("forcePush")
      .doc("pushToAudi")
      .onSnapshot((doc) => {
        if (
          doc.data().push &&
          this.state.UI.activeMenu.id !== menuItemsId.Lobby
        ) {
          this.handleClick(null, menuItems[menuItemsIndex.Lobby]);
        } else {
          return;
        }
      });
    firestore
      .collection("forcePush")
      .doc("pushToLabs")
      .onSnapshot((doc) => {
        if (
          doc.data().push &&
          this.state.UI.activeMenu.id !== menuItemsId.Game
        ) {
          this.handleClick(null, menuItems[menuItemsIndex.Game]);
        } else {
          return;
        }
      });
    firestore
      .collection("forcePush")
      .doc("pushToLobby")
      .onSnapshot((doc) => {
        if (
          doc.data().push &&
          this.state.UI.activeMenu.id !== menuItemsId.Prelobby
        ) {
          this.handleClick(null, menuItems[menuItemsIndex.Prelobby]);
        } else {
          return;
        }
      });
    firestore
      .collection("forcePush")
      .doc("restricted")
      .onSnapshot((doc) => {
        if (doc.exists) {
          this.setState({ restrictedZones: doc.data() });
        }
      });
  };

  leaderBoardListener = () => {
    firestore
      .collection("tresureHunt")
      .orderBy("score", "desc")
      .limit(10)
      .onSnapshot((doc) => {
        const arr = [];
        doc.forEach((item) => {
          arr.push({ ...item.data(), id: item.id });
        });
        // console.log(arr);
        this.setState({ gameLeaderBoard: arr });
      });
  };
  updateHSL = () => {
    let firstTime = true;
    firestore
      .collection(AppString.BACKSATGE)
      .doc("lobbyStream")
      .onSnapshot((doc) => {
        if (doc.data()) {
          if (doc.data().link) {
            if (window.parent.updateHLS) {
              window.parent.updateHLS(doc.data().link);
            }
            window.parent.firebaseLiveLink = doc.data().link;
            this.setState({ isLinkLoaded: true });
          }
        }
      });
  };
  gameFunc = (tag) => {
    // console.log(tag);
    if (this.state.gamePoints.includes(tag)) {
      return;
    }
    document.getElementById(`${tag}`).classList.add("collected");
    this.coinsound.current.audioEl.current.play();
    this.setState(
      (prev) => ({
        gamePoints: [...prev.gamePoints, gameScores[`${tag}`]],
      }),
      () => {
        if (this.state.gamePoints.length === 8) {
          let totalScore = 0;
          this.state.gamePoints.forEach((item) => {
            totalScore += item;
          });
          this.setState({ endGameScreen: true, myScore: totalScore });
        }
      }
    );
  };
  checkforGameStatus = () => {
    firestore
      .collection("tresureHunt")
      .doc(this.context.email)
      .onSnapshot((res) => {
        if (res.exists) {
          this.setState({
            myScore: res.data().score,
            playedCount: res.data().playedCount,
          });
        }
      });
  };

  updatePlayedCount = () => {
    firestore.runTransaction(async (tran) => {
      const ref = firestore.collection("tresureHunt").doc(this.context.email);

      const doc = await tran.get(ref);
      if (doc.exists) {
        await tran.update(ref, {
          playedCount: firebaseApp.firestore.FieldValue.increment(1),
        });
        return;
      } else {
        await tran.set(ref, {
          playedCount: 1,
          score: 0,
          name: this.context.displayName
            ? this.context.displayName
            : this.context.email.split("@")[0],
        });
      }
    });
  };

  updateUserScore = () => {
    let totalScore = 0;
    if (this.state.gamePoints.length !== 8) {
      this.state.gamePoints.forEach((item) => {
        totalScore += item;
      });
    } else {
      totalScore = this.state.myScore;
    }
    firestore.runTransaction(async (tran) => {
      const ref = firestore.collection("tresureHunt").doc(this.context.email);
      const doc = await tran.get(ref);
      if (doc.exists) {
        if (doc.data().score < totalScore) {
          tran.update(ref, { score: totalScore });
        } else {
          this.setState({ myScore: doc.data().score });
        }
      }
    });
  };
  gotoZoomListener = () => {
    firestore
      .collection(AppString.BACKSATGE)
      .doc("gotoStage")
      .onSnapshot((res) => {
        if (res.exists) {
          this.setState({
            showGotoZoom: res.data().show,
            gotoZoomLink: res.data().link,
          });
        }
      });
  };
  addRemainingTime = (timer) => {
    this.setState((prev) => ({ myScore: prev.myScore + timer }));
  };

  currentCanvas = (index) => {
    // console.log(index)
    const arr = [13];
    if (arr.includes(index)) {
      this.setState({ playCurrentAudio: false });
    } else {
      this.setState({ playCurrentAudio: true });
    }
    // console.log(index)
  };
  instructionVideoListener = () => {
    firestore
      .collection("showflowVideos")
      .doc("data")
      .onSnapshot((res) => {
        if (res.exists) {
          this.setState({
            instructionVideo: res.data().show,
            instructionVideoLink: res.data().link,
            funzoneLnk: res.data().funzone,
          });
        }
      });
  };
  componentDidMount = () => {
    this.updateHSL();
    this.forcePush();
    this.leaderBoardListener();
    this.checkforGameStatus();
    this.gotoZoomListener();
    this.instructionVideoListener();
    window.parent.currentCanvas = this.currentCanvas;
    window.parent.addRemainingTime = this.addRemainingTime;
    window.parent.locationChange = this.anyFunction;
    window.parent.gameitem = this.gameFunc;
    window.c = this;
    window.addEventListener("click", this.playIntroAudio);
    this.dailycoSetup();
    this.gettingMeetingRoomErrMessage();
    window.zoomlink = DBRData.zoomlink;
    firestore
      .collection("Admin")
      .doc("overlay")
      .onSnapshot((query) => {
        this.setState({
          overlayImages: query.data().images ? query.data().images : [],
        });
      });
    getLinkListener((err, data) => {
      if (err) {
        console.log(err);
        return;
      }
      window.zoomlink = data.DBRData.zoomlink;
      // console.log(data);
      this.setState({
        audiLnk: data.AudiData.link,
        zoomlink: data.DBRData.zoomlink,
        rmtpURL: data.AudiData.rmtpURL,
        showImage: data.AudiData.showImage,
        imageLink: data.AudiData.imageLink,
        streamLink: data.AudiData.streamyard,
        infolink: data.links.infodesk,
        pressroom: data.links.pressroom,
        gamezone: data.links.gamezone,
        igfilter: data.links.igfilter,
        faceyoga: data.links.faceyoga,
        lablink: data.LabData.link,
        introLink: data.AudiData.introVideoLink,
      });
    });
  };

  componentWillUnmount() {
    if (!this.AudioListenerRemoved) {
      this.AudioListenerRemoved = true;
      window.removeEventListener("click", this.playIntroAudio);
    }

    removeLinkListener();
  }

  playIntroAudio = () => {
    // console.log(this.currentAudioRef);
    if (this.currentAudioRef.current)
      this.currentAudioRef.current.audioEl.current.play();
    this.AudioListenerRemoved = true;
    window.removeEventListener("click", this.playIntroAudio);
  };

  //#region UI Function
  showInfoPopUp(message) {
    swal({
      title: message,
      icon: "info",
      className: "video-swal-modal",
      button: "continue",
    });
  }

  openLastMenu = (event) => {
    if (event) event.preventDefault();
    this.setState((state) => ({
      UI: { ...state.UI, activeMenu: state.UI.lastMenu, overlayMenu: null },
    }));
  };
  handleCustomHotspotClick = (event, hotspotDetails) => {
    if (event) event.preventDefault();
    // console.log(hotspotDetails.links);
    if (hotspotDetails.id === LobbyHotspotsId.Survey) {
      this.setState((state) => ({
        UI: {
          ...state.UI,
          showSurveyPopup: true,
          surveyDetails: hotspotDetails.links,
        },
      }));
    }
  };

  handleClick = (event, item, participant, overlayCloseCallback) => {
    // console.log(item)
    if (window.parent.audioFunc) {
      window.parent.audioFunc();
    }

    if (item.id === menuItemsId.videoPlayList) {
      this.showMediaModal(HotspotType.iframe, "/digitalRack/index.html")
      return;
    }
    if (event) event.preventDefault();
    this.closeMediaModal();
    if (
      this.state.UI.activeMenu.id === menuItemsId.Game &&
      item.id === menuItemsId.MyProfile
    ) {
      return;
    }
    // console.log(item);
    this.setState({
      playCurrentAudio: true,
      startGameScreen: true,
      endGameScreen: false,
      gamePoints: [],
    });
    if (item.id === menuItemsId.PhotoBooth) {
      this.showMediaModal(HotspotType.iframe, "/photobooth/index.html");
      this.addHotspotAnalytics("PhotoBooth");
      return;
    }
    if (item.id === menuItemsId.Lobby) {
      this.addComponentAnalytics(AnalyticsLocations.Lobby, true);
    }
    if (item.id === menuItemsId.MyProfile) {
      if (window.parent.mute) window.parent.mute();
    } else {
      if (!this.state.mute) {
        if (window.parent.unmute) window.parent.unmute();
      }
    }
    if (this.state.UI.overlayMenu) {
      if (item.id === this.state.UI.overlayMenu.id) {
        return;
      }
    } else if (item.id === this.state.UI.activeMenu.id) {
      return;
    }

    if (overlayCloseCallback) {
      this.currentOverlayCallback = overlayCloseCallback;
    }

    if (
      item.id !== menuItemsId.MyProfile
    ) {
      // this.handleHelpdeskChatClose();
      this.setState(
        (state) => ({
          showMemoryLane: false,
          UI: {
            ...state.UI,
            activeMenu: item,
            overlayMenu: null,
            lastMenu: state.UI.activeMenu,
            activeSubMenu: null,
            showHelpdeskChat: false,
            showDBRSidePanel: true,
            showStallChat: false,
          },
        }),
        () => {
          // console.log(this.state.activeMenu);
        }
      );
    } else if (item.id === menuItemsId.bdr) {
      this.handleHelpdeskChatClose();
      this.handleVideoRoomSelection(event, item.room, (err) => {
        if (!err) {
          this.setState((state) => ({
            UI: {
              ...state.UI,
              activeMenu: item,
              overlayMenu: null,
              lastMenu: state.UI.activeMenu,
              activeSubMenu: item.subMenus[DBRSubMenuIndex.Call],
              showHelpdeskChat: false,
              showDBRSidePanel: true,
              showStallChat: false,
            },
          }));
        }
      });
    } else {
      this.setState((state) => ({
        UI: { ...state.UI, overlayMenu: item, lastMenu: state.UI.activeMenu },
      }));
    }
  };

  handleSubmenuItemClick = (event, item) => {
    if (event) event.preventDefault();
    if (this.state.UI.activeSubMenu)
      if (this.state.UI.activeSubMenu.id === item.id) {
        return;
      }
    if (
      this.state.UI.activeMenu.id === menuItemsId.Audi &&
      item.id === SubMenuId.POll
    ) {
      this.handleClick(event, menuItems[menuItemsIndex.bdr]);
      return;
    }
    // console.log(item);
    if (item.id === 7) {
      this.setState({ showLiveIframe: true });
      this.showMediaModal(HotspotType.iframe, this.state.streamLink);
      return;
    }
    if (item.id === 6) {
      this.setState({ showOverlayPopup: true });
      return;
    }
    if (item.id === SubMenuId.GoToStage) {
      signOut();
    }

    if (this.state.UI.activeMenu.id === menuItemsId.bdr) {
      if (item.id === SubMenuId.Call) {
        this.setState((prevState) => ({
          UI: {
            ...prevState.UI,
            showDBRSidePanel: true,
            activeSubMenu: item,
          },
        }));
      } else {
        this.setState((prevState) => ({
          UI: {
            ...prevState.UI,
            activeSubMenu: item,
            showDBRSidePanel: false,
          },
        }));
      }
    }

    if (this.state.UI.activeMenu.id !== menuItemsId.bdr) {
      this.setState((prevState) => ({
        UI: {
          ...prevState.UI,
          activeSubMenu: item,
          showDBRSidePanel: false,
        },
      }));
    }
  };

  closeSubMenu = (event) => {
    if (event) event.preventDefault();
    this.setState((prevState) => ({
      UI: {
        ...prevState.UI,
        activeSubMenu: null,
        showMediaModal: false,
      },
      MediaModalInfo: {
        ...prevState.MediaModalInfo,
        link: "",
        type: null,
      },
    }));
  };

  hideOverlayMenu = (event) => {
    if (event) event.preventDefault();
    if (this.state.UI.overlayMenu) {
      this.setState((state) => ({
        UI: { ...state.UI, overlayMenu: null, showAskExpertError: false },
      }));
    }
    if (this.currentOverlayCallback) {
      this.currentOverlayCallback();
      this.currentOverlayCallback = null;
    }
  };

  showMediaModal = (hotspotType, mediaLink) => {
    if (hotspotType === HotspotType.anchor) {
      window.open(mediaLink, "_blank");
      return;
    }
    // console.log(hotspotType, mediaLink);
    if (hotspotType === HotspotType.chatbot) {
      window.lastChatBotRef = mediaLink;
      mediaLink.enabled = false;
      this.handleHelpdeskChatbutton();
      return;
    }
    this.setState((prevState) => ({
      UI: {
        ...prevState.UI,
        showMediaModal: true,
      },
      MediaModalInfo: {
        ...prevState.MediaModalInfo,
        link: mediaLink ? mediaLink : "",
        type: hotspotType,
      },
    }));
  };

  handleMedialModalFromOverlay = (hotspotType, link) => {
    this.hideOverlayMenu();
    this.showMediaModal(hotspotType, link);
  };

  closeMediaModal = () => {
    this.setState({ showRotate: true });
    if (!this.state.mute) {
      if (window.parent.unmute) {
        window.parent.unmute();
      }
    }
    this.setState((prevState) => ({
      showLiveIframe: false,
      UI: {
        ...prevState.UI,
        showMediaModal: false,
      },
      MediaModalInfo: {
        ...prevState.MediaModalInfo,
        link: "",
        type: null,
      },
    }));
  };
  //#endregion

  handleTeamOptionSelection = (event, teams) => {
    // event.preventDefault();
    window.open(teams.link, "_blank");
    this.hideOverlayMenu(event);
  };

  checkIfAudioCanPlayUnderMediaModal = () => {
    if (this.state.UI.showMediaModal) {
      if (this.state.MediaModalInfo.type === HotspotType.pdf) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  handleHelpdeskChatClose = () => {
    if (window.lastChatBotRef) window.lastChatBotRef.enabled = true;
    if (this.state.HelpdeskChat.showChat) {
      this.setState({
        HelpdeskChat: {
          showChat: false,
          showButton: true,
        },
      });
    }
  };

  handleHelpdeskChatbutton = () => {
    if (this.state.HelpdeskChat.showButton) {
      this.setState({
        HelpdeskChat: {
          showChat: true,
          showButton: false,
        },
      });
    }
  };

  handleLobbyInternalState = (internalState) => {
    // console.log("innnnnnnnnnnnnnnnnnnnnnn");
    switch (internalState) {
      case "Infodesk":
        this.setState((prevState) => ({
          UI: {
            ...prevState.UI,
            showHelpdeskChat: true,
          },
        }));
        break;
      default:
        this.setState((prevState) => ({
          UI: {
            ...prevState.UI,
            showHelpdeskChat: false,
            showStallChat: false,
          },
          HelpdeskChat: {
            showChat: false,
            showButton: true,
          },
        }));
    }
  };

  handleSceneTutorial = (type) => {
    if (type === "end") {
      this.setState((prevState) => ({
        UI: {
          ...prevState.UI,
          isInteractable: true,
        },
      }));
    }
  };

  //#region Analytics
  handleHotspotAnalytics = (hotspotDetails) => {
    // console.log(hotspotDetails.id);
    this.addHotspotAnalytics(hotspotDetails.id);
  };

  addComponentAnalytics = (location, value) => {
    //add to user
    if (value) {
      this.addHotspotAnalytics(location);
      this.addLocationAnalytics(location, value);
    }
  };

  addLocationAnalytics = (location, value) => {
    if (value) {
      updateUserLocation(this.context, location);
    }
  };

  addHotspotAnalytics = (name) => {
    //call some firebase function
    addRealtimeHotspotAnalytics(this.context, name);
  };

  addCustomHotspotAnalytics = (detials) => {
    addCustomRealtimeHotspotAnalytics(this.context, detials);
  };
  //#endregion

  //#region Dailyco Function
  handleVideoRoomSelection = async (event, room, callback) => {
    if (event) event.preventDefault();
    try {
      // console.log(room);
      if (this.state.DBRVideoCall.roomAdmin) {
        // console.log(this.state.DBRVideoCall.roomAdmin);
        if (this.state.DBRVideoCall.roomAdmin.roomName === room.roomName) {
          this.setState((prevState) => ({
            DBRVideoCall: {
              ...prevState.DBRVideoCall,
              room: room,
            },
          }));
          if (callback) {
            callback(null);
          }
          return;
        }
      }

      const isLive = await checkDailycoRoomStatus(room.docName);
      if (isLive) {
        this.setState((prevState) => ({
          DBRVideoCall: {
            ...prevState.DBRVideoCall,
            room: room,
          },
        }));
        if (callback) {
          callback(null);
        }
      } else {
        this.showInfoPopUp("Call has not started yet, please wait");
        if (callback) {
          callback(true);
        }
      }
    } catch (error) {
      if (callback) {
        callback(true);
      }
      console.log(error);
    }
  };

  dailycoSetup = () => {
    checkForDailycoAdmin(this.context)
      .then((data) => {
        this.setState((prevState) => ({
          DBRVideoCall: {
            ...prevState.DBRVideoCall,
            roomAdmin: data,
          },
        }));
      })
      .catch((err) => {
        if (err.code !== "NoAdmin") console.log(err);
      });

    getDailycoRoomDetails()
      .then((data) => {
        // console.log(data);
        this.handleVideoRoomSelection(null, data[Object.keys(data)[0]]);
        this.setState((prevState) => ({
          DBRVideoCall: {
            ...prevState.DBRVideoCall,
            roomOptions: data,
          },
        }));
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  closeDBRVideoCallSidePanel = () => {
    this.setState((prevState) => ({
      UI: {
        ...prevState.UI,
        showDBRSidePanel: false,
        activeSubMenu: null,
      },
    }));
  };

  openDBRZoomLink = (link, event) => {
    if (event) {
      event.preventDefault();
    }
    window.location.href = link;
    // window.open(link, "_blank")
  };
  //#endregion

  //#region Twilio VideoCAll

  gettingMeetingRoomErrMessage = async () => {
    const Messagedoc = await firestore
      .collection(AppString.BACKSTAGE)
      .doc(AppString.MEETINGROOMMESSAGE)
      .get();
    if (Messagedoc.data) {
      this.MeetingRoomMessage = Messagedoc.data().meetingRoomMsg;
      this.busyRoomMessage = Messagedoc.data().busyRoomMessage;
    }
  };
  deleteOneOverlayImage = (e, pos, item) => {
    if (item.enabled) {
      swal("Selected Image is in use!");
      return;
    }
    this.setState({ loading: true });
    let arr = this.state.overlayImages;
    delete arr[pos];

    arr = arr.filter((item) => item !== null);
    // console.log(arr);
    firestore
      .collection("Admin")
      .doc("overlay")
      .set({ images: [...arr] })
      .then(() => {
        // console.log("added");
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  };
  checkAvailableVideoCallRoom = async (event, stallId) => {
    event.preventDefault();
    try {
      // console.log(this.context);
      const slot = await getAvailableTwilioVideoCallRoom(
        this.context.email,
        stallId
      );
      let room = {
        roomId: slot.id,
        roomName: slot.name,
        roomParentId: "UltraTech",
        isAdmin: slot.isAdmin,
      };
      this.setState((state) => ({
        TwilioVideoCall: {
          ...state.TwilioVideoCall,
          room: room,
          showVideoCall: true,
          slot: slot,
          stallId: stallId,
        },
      }));
      // console.log(room);
    } catch (err) {
      console.log(err);
      if (err.code === "NoRoomAvaliable") {
        swal({
          text: "Videocall rooms are occupied. Please come back later, Thanks.",
        });
      }
      this.setState((state) => ({
        UI: { ...state.UI, showAskExpertError: true },
      }));
    }
  };
  clearTwilioVideoCallRoom = async () => {
    try {
      this.setState((state) => ({
        TwilioVideoCall: { ...state.TwilioVideoCall, showVideoCall: false },
        UI: { ...state.UI, overlayMenu: null, showAskExpertError: false },
      }));

      if (this.state.TwilioVideoCall.slot.id) {
        setTimeout(async () => {
          await clearTwilioVideoCallRoom(
            this.state.TwilioVideoCall.slot.id,
            this.context.email,
            this.state.TwilioVideoCall.stallId
          );
          this.setState((state) => ({
            TwilioVideoCall: {
              ...state.TwilioVideoCall,
              slot: null,
              room: null,
            },
          }));
        }, 3000);
      } else {
        console.error("No Room Id found for user");
      }
    } catch (err) {
      console.log(err);
    }
  };
  currentSlotRest = async (event) => {
    if (event) event.preventDefault();
    try {
      // console.log(this.state.TwilioVideoCall.slot);
      if (this.state.TwilioVideoCall.slot.id) {
        await clearTwilioVideoCallRoom(
          this.state.TwilioVideoCall.slot.id,
          "-1",
          this.state.TwilioVideoCall.stallId
        );
      } else {
        console.error("No Room Id found for user");
      }
    } catch (err) {
      console.log(err);
    }
  };

  showInfoPopUp = (message) => {
    swal({
      title: message,
      className: "video-swal-modal",
      button: "continue",
    });
  };

  showMeetingRoomPopup = () => {
    this.showInfoPopUp(this.MeetingRoomMessage);
  };

  showMeetingRoomBusyPopup = () => {
    this.showInfoPopUp(this.busyRoomMessage);
  };
  updateOverlayImage = (link, pos) => {
    this.setState({ loading: true });
    firestore
      .collection("backStage")
      .doc("staticData")
      .update({
        AudiData: {
          imageLink: link,
          link: this.state.audiLnk,
          showImage: this.state.showImage,
          rmtpURL: this.state.rmtpURL,
        },
      })
      .then(() => {
        // console.log("done");
        this.setState((prev) => {
          const arr = prev.overlayImages.map((item) => {
            return { ...item, enabled: false };
          });
          arr[pos] = { enabled: true, link };
          // console.log(arr);
          firestore
            .collection("Admin")
            .doc("overlay")
            .set({ images: [...arr] })
            .then(() => {
              // console.log("added");
              this.setState({ loading: false });
            })
            .catch((err) => {
              console.log(err);
              this.setState({ loading: false });
            });
          this.setState({ loading: false });
          return arr;
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  handleStallCallHotspot = (event, hotspotDetails) => {
    if (hotspotDetails.hotspotType !== HotspotType.videoCall) {
      return;
    }
    this.checkAvailableVideoCallRoom(event, hotspotDetails.roomDetails.id);
  };
  //#endregion

  //#region  stall chat
  handleStallChatHotspot = (event, hotspotDetails) => {
    // console.log(hotspotDetails.hotspotType);

    if (hotspotDetails.hotspotType !== HotspotType.stallChat) {
      return;
    }
    if (hotspotDetails.roomDetails) {
      this.setState((prev) => ({
        UI: {
          ...prev.UI,
          showStallChat: true,
        },
        stallChat: {
          id: hotspotDetails.roomDetails.id,
        },
      }));
    } else {
      this.showInfoPopUp(
        "We are having some issue in opening chat for you. Please come back later"
      );
    }
  };

  uploadFile = (e) => {
    this.setState({ loading: true });
    const uploadTask = storage
      .ref(`/images/${e.target.files[0].name}`)
      .put(e.target.files[0]);
    uploadTask.on(
      "state_changed",
      (snapShot) => {
        // console.log(snapShot);
      },
      (err) => {
        console.log(err);
        this.setState({ loading: false });
      },
      () => {
        storage
          .ref("images")
          .child(e.target.files[0].name)
          .getDownloadURL()
          .then((fireBaseUrl) => {
            firestore
              .collection("Admin")
              .doc("overlay")
              .update({
                images: [
                  ...this.state.overlayImages,
                  { enabled: false, link: fireBaseUrl },
                ],
              })
              .then(() => {
                this.setState({ loading: false });
                // console.log(this.state.overlayImages);
              })
              .catch(() => {
                this.setState({ loading: false });
              });
          });
      }
    );
  };
  closePopup = () => {
    // console.log("*****");
    this.setState({ showIntro: false });
    localStorage.setItem("introVisited", true);
  };
  handleStallChatHotspotClose = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState((prev) => ({
      UI: {
        ...prev.UI,
        showStallChat: false,
      },
      stallChat: {
        id: "",
      },
    }));
  };

  //#endregion
  showOverlayOrNot = (e) => {
    this.setState({ loading: true });
    firestore
      .collection("backStage")
      .doc("staticData")
      .update({
        AudiData: {
          imageLink: this.state.imageLink,
          link: this.state.audiLnk,
          showImage: e.target.checked,
          rmtpURL: this.state.rmtpURL,
        },
      })
      .then(() => {
        this.setState({ loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <>
        <div className="wrapper">
          {this.state.showClosedPopup && (
            <div className="closedPopup">
              <div>
                <img
                  src={cut}
                  alt=""
                  onClick={() => {
                    this.setState({ showClosedPopup: false });
                  }}
                />
                <h2>Playing limit full</h2>
              </div>
            </div>
          )}

          {this.state.alreadyCollected && (
            <div className="closedPopup">
              <div>
                <img
                  src={cut}
                  alt=""
                  onClick={() => {
                    this.setState({ alreadyCollected: false });
                  }}
                />
                <h2>Already Collected</h2>
              </div>
            </div>
          )}

          {this.state.showGotoZoom && (
            <div className="lobbyTutContainer">
              <div className="tut-box zoom-p">
                <div className="head">
                  <img src="/assets/images/login/login-logo.png" alt="" />
                </div>
                <div
                  className="content"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <p>Step: 1</p>
                  <h2 style={{ display: "flex", alignItems: "center" }}>
                    Download Zoom Backgrounds{" "}
                    <div
                      className="d-arrow"
                      style={{
                        position: "relative",
                        right: "unset",
                        bottom: "unset",
                        zIndex: "unset",
                        marginLeft: "1rem",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        const a1 = document.createElement("a");
                        const a2 = document.createElement("a");
                        a1.setAttribute("download", "Background1.jpg");
                        a2.setAttribute("download", "Background2.jpg");
                        a1.setAttribute("href", "/assets/images/zoom-bg-1.jpg");
                        a2.setAttribute("href", "/assets/images/zoom-bg-2.jpg");
                        a1.click();
                        a2.click();
                      }}
                    >
                      <AiOutlineArrowDown />
                    </div>
                  </h2>
                  <br />
                  <p>Step: 2</p>

                </div>
                <div className="box-button" style={{ display: 'flex', flexDirection: "column", justifyContent: "center" }}>
                  <button
                    onClick={() => {
                      this.showMediaModal(
                        HotspotType.anchor,
                        this.state.gotoZoomLink
                      );
                    }}
                  >
                    Join Zoom Meeting
                  </button>
                </div>
              </div>
            </div>
          )}
          <section
            className={`loggedin-page has-right-menu min-height-full min-height-full image-bg ${isIOS ? "ios-page" : ""
              } ${isIPad13 ? "on-ipad" : ""} ${window.parent.ios_V
                ? window.parent.ios_V === 15
                  ? "ios-15"
                  : ""
                : ""
              } ${window.parent.ios_V
                ? window.parent.ios_V === 15 && !isMobileSafari
                  ? "ios-15-ch"
                  : ""
                : ""
              } ${window.parent.ios_V2
                ? window.Number(window.parent.ios_V2) >= window.Number("14.2")
                  ? "ios-14-2"
                  : ""
                : ""
              }`}
          >
            {this.state.showMemoryLane && (
              <MemoryLane
                showMediaModal={this.showMediaModal}
                hideMemoryLane={() => {
                  this.setState({ showMemoryLane: false });
                }}
              />
            )}
            {!this.state.showMemoryLane &&
              this.state.UI.activeMenu.id !== menuItemsId.Game &&
              this.state.UI.activeMenu.id !== menuItemsId.LeaderBoard && (
                <>
                  {this.state.mute ? (
                    <div
                      className={`mute ${isIOS ? "ios-mute" : ""}`}
                      style={{ right: isIOS ? "16rem" : "19rem" }}
                      onClick={() => {
                        // if (window.parent.mute) window.parent.unmute();
                        this.setState({ mute: false });
                      }}
                    >
                      <BiVolumeMute color="#fff" />
                    </div>
                  ) : (
                    <div
                      className={`mute ${isIOS ? "ios-mute" : ""}`}
                      style={{ right: isIOS ? "16rem" : "19rem" }}
                      onClick={() => {
                        // if (window.parent.mute) window.parent.mute();
                        this.setState({ mute: true });
                      }}
                    >
                      <GoUnmute color="#fff" />
                    </div>
                  )}
                </>
              )}

            {this.state.showOverlayPopup && (
              <div className="overlay__main">
                <div className="upload__div">
                  <div className="toggle">
                    <h2>SHOW / HIDE</h2>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={this.state.showImage}
                        onChange={(e) => {
                          this.showOverlayOrNot(e);
                        }}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                  <img src={right__wing} alt="" className="right__wing" />
                  <img src={bottom__wing} alt="" className="bottom__wing" />
                  {this.state.loading ? (
                    <div className="loading__cont">
                      <img src={spinner} alt="" style={{ maxWidth: "5rem" }} />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="img__heading">
                    <h1>UPLOAD</h1>
                    <div className="upload__line"></div>
                  </div>
                  <div className="images__area">
                    {this.state.overlayImages.map((item, pos) => {
                      return (
                        <div className="image__cont" key={pos}>
                          <div
                            className="delete__img"
                            onClick={(e) => {
                              this.deleteOneOverlayImage(e, pos, item);
                            }}
                          >
                            <img src={delete__icon} alt="" />
                          </div>
                          {item.enabled && (
                            <div className="tick">
                              <img src={selected} alt="" />
                            </div>
                          )}
                          <img
                            src={item.link}
                            onClick={() => {
                              this.updateOverlayImage(item.link, pos);
                            }}
                          />
                          ;
                        </div>
                      );
                    })}
                    <div className="file__upload">
                      <label htmlFor="overlay-upload">
                        <div>
                          <img src={add} alt="" />
                          <h1>Add Image</h1>
                        </div>
                      </label>
                      <input
                        id="overlay-upload"
                        type="file"
                        onChange={(e) => {
                          this.uploadFile(e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="done__btn">
                    <Button
                      variant="contained"
                      color="secondary"
                      className="img__conti__btn"
                      onClick={(e) => {
                        this.setState({ showOverlayPopup: false });
                      }}
                    >
                      DONE
                      <img src={arrow} alt="" className="arrow" />
                    </Button>
                  </div>
                </div>
              </div>
            )}
            <CustomNotification firestore={firestore}></CustomNotification>
            {this.state.showIntro && (
              <article
                style={{
                  zIndex: 1000000000,
                  width: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
                className={`img-bg videoBox h-100 zIndex-16`}
                id="play"
              >
                <div className="media-modal">
                  <>
                    <div className="media-modal-content">
                      <ReactPlayer
                        loop={false}
                        config={{
                          youtube: {
                            playerVars: { showinfo: 1 },
                          },
                        }}
                        playing={true}
                        style={{ position: "relative", zIndex: "2" }}
                        url={`${this.state.introLink}`}
                        controls={true}
                        muted={this.state.introVideoMuted}
                        playsinline={true}
                        width="100%"
                        height="100%"
                        onPlay={() => {
                          if (window.parent.mute) window.parent.mute();
                        }}
                        onEnded={() => {
                          this.closePopup();
                        }}
                      />
                      <div
                        className="blocker"
                        style={{
                          left: "0",
                          pointerEvents: "none",
                          zIndex: "1",
                        }}
                      >
                        <div className="lds-dual-ring"></div>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "3rem",
                        height: "70%",
                        position: "relative",
                      }}
                    >
                      <img
                        src={ImageString.CLOSEBUTTON}
                        className="closeButton-mediaModal"
                        alt="MediaModalCLoseButton"
                        style={{
                          position: "absolute",
                          right: "-1rem",
                          top: isIOS ? "0" : "-3rem",
                          width: "3rem",
                        }}
                        onClick={() => {
                          this.setState({ showIntro: false });
                          this.closeMediaModal();
                          localStorage.setItem("introVisited", true);
                        }}
                      ></img>
                    </div>
                  </>
                </div>
              </article>
            )}

            {this.state.funzone &&
              this.state.UI.activeMenu.id === menuItemsId.Lobby && (
                <article
                  style={{
                    zIndex: 1000000000,
                    width: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                  className={`img-bg videoBox h-100 zIndex-16`}
                  id="play"
                >
                  <div className="media-modal">
                    <>
                      <div className="media-modal-content">
                        <ReactPlayer
                          loop={false}
                          config={{
                            youtube: {
                              playerVars: { showinfo: 1 },
                            },
                          }}
                          playing={true}
                          style={{ position: "relative", zIndex: "2" }}
                          url={`${this.state.funzoneLnk}`}
                          controls={true}
                          muted={this.state.introVideoMuted}
                          playsinline={true}
                          width="100%"
                          height="100%"
                          onPlay={() => {
                            if (window.parent.mute) window.parent.mute();
                          }}
                          onEnded={() => {
                            this.closePopup();
                            this.setState({ funzone: false });
                          }}
                        />
                        <div
                          className="blocker"
                          style={{
                            left: "0",
                            pointerEvents: "none",
                            zIndex: "1",
                          }}
                        >
                          <div className="lds-dual-ring"></div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "3rem",
                          height: "70%",
                          position: "relative",
                        }}
                      >
                        <img
                          src={ImageString.CLOSEBUTTON}
                          className="closeButton-mediaModal"
                          alt="MediaModalCLoseButton"
                          style={{
                            position: "absolute",
                            right: "-1rem",
                            top: isIOS ? "0" : "-3rem",
                            width: "3rem",
                          }}
                          onClick={() => {
                            this.setState({ funzone: false });
                            this.closeMediaModal();
                          }}
                        ></img>
                      </div>
                    </>
                  </div>
                </article>
              )}
            {this.state.instructionVideo &&
              this.state.UI.activeMenu.id === menuItemsId.Lobby &&
              true &&
              !this.state.showMemoryLane &&
              !this.state.funzone && (
                <article
                  style={{
                    zIndex: 1000000000,
                    width: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                  className={`img-bg videoBox h-100 zIndex-16`}
                  id="play"
                >
                  <div className="media-modal">
                    <>
                      <div className="media-modal-content">
                        <ReactPlayer
                          loop={false}
                          config={{
                            youtube: {
                              playerVars: { showinfo: 1 },
                            },
                          }}
                          playing={true}
                          style={{ position: "relative", zIndex: "2" }}
                          url={`${this.state.instructionVideoLink}`}
                          controls={true}
                          muted={this.state.introVideoMuted}
                          playsinline={true}
                          width="100%"
                          height="100%"
                          onPlay={() => {
                            if (window.parent.mute) window.parent.mute();
                          }}
                          onEnded={() => {
                            this.closePopup();
                            this.setState({ instructionVideo: false });
                          }}
                        />
                        <div
                          className="blocker"
                          style={{
                            left: "0",
                            pointerEvents: "none",
                            zIndex: "1",
                          }}
                        >
                          <div className="lds-dual-ring"></div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "3rem",
                          height: "70%",
                          position: "relative",
                        }}
                      >
                        <img
                          src={ImageString.CLOSEBUTTON}
                          className="closeButton-mediaModal"
                          alt="MediaModalCLoseButton"
                          style={{
                            position: "absolute",
                            right: "-1rem",
                            top: isIOS ? "0" : "-3rem",
                            width: "3rem",
                          }}
                          onClick={() => {
                            this.setState({ instructionVideo: false });
                            this.closeMediaModal();
                          }}
                        ></img>
                      </div>
                    </>
                  </div>
                </article>
              )}

            {this.state.UI.showMediaModal && (
              <>
                <article
                  style={{
                    zIndex: 10000000000,
                    width: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                  className={`img-bg videoBox h-100 zIndex-16`}
                  id="play"
                >
                  <div className="media-modal">
                    {this.state.MediaModalInfo.type ===
                      HotspotType.videoPlayer && (
                        <VideoPlayer
                          videoData={VideoPlayerData}
                          close={() => this.closeMediaModal()}
                        ></VideoPlayer>
                      )}
                    {this.state.MediaModalInfo.type ===
                      HotspotType.PortraitIMGgraphics && (
                        <>
                          <div
                            className="qr__popup"
                            style={{
                              height: "70vh",
                              width: "calc(70vh * 0.5)",

                              background: `#fff url(${this.state.MediaModalInfo.link.bg})`,
                              backgroundPosition: "center",
                              backgroundSize: "cover",
                              backgroundRepeat: "no-repeat",
                            }}
                          ></div>
                          <div
                            style={{
                              width: "3rem",
                              height: "70vh",
                              position: "relative",
                            }}
                          >
                            <img
                              src={ImageString.CLOSEBUTTON}
                              className="closeButton-mediaModal"
                              alt="MediaModalCLoseButton"
                              style={{
                                position: "absolute",
                                right: "-1rem",
                                top: isIOS ? "0" : "-3rem",
                                width: "3rem",
                              }}
                              onClick={this.closeMediaModal}
                            ></img>
                          </div>
                        </>
                      )}
                    {this.state.MediaModalInfo.type ===
                      HotspotType.ImgGrapics && (
                        <>
                          <div
                            className="qr__popup"
                            style={{
                              height: "70vh",
                              width: "calc(70vh * 1.77)",
                              background: `#fff url(${this.state.MediaModalInfo.link.bg})`,
                              backgroundPosition: "center",
                              backgroundSize: "cover",
                              backgroundRepeat: "no-repeat",
                            }}
                          ></div>
                        </>
                      )}
                    {this.state.MediaModalInfo.type ===
                      HotspotType.pdfPlayer && (
                        <PdfPlayer
                          data={this.state.MediaModalInfo.link}
                          close={() => this.closeMediaModal()}
                        ></PdfPlayer>
                      )}
                    {this.state.MediaModalInfo.type === HotspotType.QRcode && (
                      <>
                        <div className="qr__popup">
                          <h2>{this.state.MediaModalInfo.link.text}</h2>
                          <img
                            src={this.state.MediaModalInfo.link.img}
                            alt=""
                          />
                        </div>
                        <div
                          style={{
                            width: "3rem",
                            height: "50%",
                            position: "relative",
                          }}
                        >
                          <img
                            src={ImageString.CLOSEBUTTON}
                            className="closeButton-mediaModal"
                            alt="MediaModalCLoseButton"
                            style={{
                              position: "absolute",
                              right: "-1rem",
                              top: isIOS ? "0" : "-3rem",
                              width: "3rem",
                            }}
                            onClick={this.closeMediaModal}
                          ></img>
                        </div>
                      </>
                    )}
                    {this.state.MediaModalInfo.type === HotspotType.pdf && (
                      <>
                        <iframe
                          title={"pdf"}
                          className="media-modal-content pdf-content"
                          src={`${this.state.MediaModalInfo.link}?page=hsn#toolbar=1&view=FitH`}
                        ></iframe>
                      </>
                    )}
                    {this.state.MediaModalInfo.type === HotspotType.iframe && (
                      <>
                        {this.state.showLiveIframe && (
                          <div className="stream__header"></div>
                        )}
                        <iframe
                          allowvr="yes"
                          allowfullscreen
                          mozallowfullscreen="true"
                          webkitallowfullscreen="true"
                          allow="camera *;microphone * vr; xr; accelerometer; magnetometer; gyroscope; autoplay;"
                          title={"iframe"}
                          className={`media-modal-content-iframe ${this.state.showLiveIframe && "fullscreen-iframe"
                            }`}
                          src={this.state.MediaModalInfo.link}
                        ></iframe>
                      </>
                    )}
                    {this.state.MediaModalInfo.type === HotspotType.video && (
                      <>
                        <div className="media-modal-content">
                          <ReactPlayer
                            config={{
                              youtube: {
                                playerVars: { showinfo: 1 },
                              },
                            }}
                            style={{ position: "relative", zIndex: "2" }}
                            playing={true}
                            url={this.state.MediaModalInfo.link}
                            controls={true}
                            width="100%"
                            height="100%"
                          />
                          <div
                            className="blocker"
                            style={{
                              left: "0",
                              pointerEvents: "none",
                              zIndex: "1",
                            }}
                          >
                            <div className="lds-dual-ring"></div>
                          </div>
                        </div>
                        <div
                          style={{
                            width: "3rem",
                            height: "70%",
                            position: "relative",
                          }}
                        >
                          <img
                            src={ImageString.CLOSEBUTTON}
                            className="closeButton-mediaModal"
                            alt="MediaModalCLoseButton"
                            style={{
                              position: "absolute",
                              right: "-1rem",
                              top: isIOS ? "0" : "-3rem",
                              width: "3rem",
                            }}
                            onClick={this.closeMediaModal}
                          ></img>
                        </div>
                      </>
                    )}
                    {this.state.MediaModalInfo.type === HotspotType.image && (
                      <img
                        title={"image"}
                        className="media-modal-content-image"
                        src={this.state.MediaModalInfo.link}
                        alt="mediaModalImage"
                      ></img>
                    )}
                    {this.state.MediaModalInfo.type !==
                      HotspotType.videoPlayer &&
                      this.state.MediaModalInfo.type !==
                      HotspotType.pdfPlayer &&
                      this.state.MediaModalInfo.type !== HotspotType.QRcode &&
                      this.state.MediaModalInfo.type !== HotspotType.video &&
                      this.state.MediaModalInfo.type !==
                      HotspotType.PortraitIMGgraphics && (
                        <img
                          src={ImageString.CLOSEBUTTON}
                          className="closeButton-mediaModal"
                          alt="MediaModalCLoseButton"
                          onClick={this.closeMediaModal}
                        ></img>
                      )}
                  </div>
                </article>
              </>
            )}

            {this.state.UI.activeMenu.id === menuItemsId.Prelobby && (
              <Scene
                isImageScene={isIOS || window.parent.isMac15}
                initalImage={ImageString.LOBBYLOOP}
                ShowMediaModal={this.showMediaModal}
                initialVideo={VideoString.LOBBYLOOP}
                firstVideoFrame={ImageString.LOBBYLOOP}
                initialHotspot={LobbyHotspots}
                globalBackButton={false}
                changeComponenet={this.handleClick}
                ratio={videoRatios}
                // for tut to work also pass name
                sceneName="PreLobby"
                showTut={false}
                tutComponent={LobbyTut}
                showingTutorialEvent={this.handleSceneTutorial}
                addAnalytics={(value) =>
                  this.addComponentAnalytics(AnalyticsLocations.PreLobby, value)
                }
              ></Scene>
            )}
            {this.state.UI.activeMenu.id === menuItemsId.Lobby && (
              <iframe
                src="/lastBuild/lastBuildn/index.htm"
                frameBorder="0"
                style={{
                  height: "100vh",
                  width: "100%",
                  zIndex: 2,
                  position: "relative",
                  // display:
                  //   this.state.UI.activeMenu.id === menuItemsId.Lobby
                  //     ? "block"
                  //     : "none",
                }}
                className={`"main-frame" ${isIOS ? "lobby-ios" : ""}`}
              ></iframe>
            )}

            {this.state.UI.activeMenu.id === menuItemsId.LeaderBoard && (
              <ScoreCard
                context={this.context}
                scores={this.state.gameLeaderBoard}
                yScores={this.state.myScore}
                backToLobby={(e) => {
                  this.handleClick(e, menuItems[menuItemsIndex.Lobby]);
                }}
              />
            )}
            {this.state.UI.activeMenu.id === menuItemsId.Game && (
              <>
                <Game
                  handleClick={this.handleClick}
                  context={this.context}
                  updatePlayedCount={this.updatePlayedCount}
                  startGameScreen={this.state.startGameScreen}
                  stratScreneState={(val) => {
                    this.setState({ startGameScreen: val });
                  }}
                  endScreenState={(val) => {
                    let currScore = 0;
                    this.state.gamePoints.forEach((item) => {
                      currScore += item;
                    });
                    this.setState({ endGameScreen: val, myScore: currScore });
                  }}
                  myScore={this.state.myScore}
                  currentMenuItem={this.state.UI.activeMenu.id}
                  endGameScreen={this.state.endGameScreen}
                  backButton={(e) => {
                    this.updateUserScore();
                    this.handleClick(e, menuItems[menuItemsIndex.Lobby]);
                  }}
                />
              </>
            )}

            {this.state.UI.activeMenu.id === menuItemsId.Lobby && (
              <>
                {this.state.UI.showHelpdeskChat && (
                  <>
                    {this.context.email && this.state.HelpdeskChat.showChat && (
                      <>
                        <ClientChat
                          channel={this.context.email}
                          user={{
                            id: this.context.email,
                            name: this.context.displayName,
                          }}
                          closeChat={this.handleHelpdeskChatClose}
                          visibility={true}
                        ></ClientChat>
                      </>
                    )}
                  </>
                )}
              </>
            )}

            {this.state.UI.activeSubMenu &&
              this.state.UI.activeMenu.id === menuItemsId.bdr &&
              this.state.UI.activeSubMenu.id === SubMenuId.Chat && (
                <div className="stallChatContainer stallChatContainer-global">
                  <img
                    src={ImageString.CLOSEBUTTON}
                    className="closeButton-mediaModal"
                    alt="MediaModalCLoseButton"
                    onClick={() =>
                      this.setState((prev) => ({
                        UI: {
                          ...prev.UI,
                          activeSubMenu: null,
                        },
                      }))
                    }
                  ></img>
                  <iframe
                    src={`${StaticLinks.publicChat}`}
                    title="publicChat"
                  ></iframe>
                  <div
                    className={`blocker ${this.state.UI.fadeIntroImage ? "d-none" : ""
                      }`}
                    style={{ zIndex: "-1" }}
                  >
                    <div className="lds-dual-ring"></div>
                  </div>
                </div>
              )}
            {this.state.UI.showGlobalChat &&
              this.state.UI.hideGlobalChat &&
              this.state.UI.activeMenu.id !== menuItemsId.Game && (
                <div
                  className="chatButton"
                  style={
                    this.state.UI.activeMenu &&
                      this.state.UI.activeMenu.id === menuItemsId.Learning // && this.state.UI.showDBRSidePanel
                      ? {
                        right: "auto",
                        left: "0",
                        zIndex: "2",
                      }
                      : {
                        zIndex: "2",
                        display:
                          !this.state.UI.activeMenu ||
                            this.state.UI.activeMenu.id !==
                            menuItemsId.Networking
                            ? "flex"
                            : "none",
                      }
                  }
                  onClick={() =>
                    this.setState((prev) => ({
                      UI: {
                        ...prev.UI,
                        hideGlobalChat: false,
                      },
                    }))
                  }
                >
                  CHAT
                </div>
              )}
            {this.state.UI.showGlobalChat &&
              this.state.UI.activeMenu.id !== menuItemsId.Game && (
                <div
                  className={`stallChatContainer stallChatContainer-global`}
                  style={
                    this.state.UI.activeMenu &&
                      this.state.UI.activeMenu.id === menuItemsId.Learning // && this.state.UI.showDBRSidePanel
                      ? {
                        right: "auto",
                        left: "0",
                        pointerEvents: this.state.UI.hideGlobalChat
                          ? "none"
                          : "all",
                      }
                      : {
                        right: "0",
                        left: "auto",
                        pointerEvents: this.state.UI.hideGlobalChat
                          ? "none"
                          : "all",
                      }
                  }
                >
                  <img
                    src={ImageString.CLOSEBUTTON}
                    className={`closeButton-mediaModal ${this.state.UI.hideGlobalChat ? "d-none" : ""
                      } chat-img`}
                    alt="MediaModalCLoseButton"
                    onClick={() =>
                      this.setState((prev) => ({
                        UI: {
                          ...prev.UI,
                          hideGlobalChat: true,
                        },
                      }))
                    }
                  ></img>

                  <iframe
                    src={`${StaticLinks.publicChat}`}
                    className={`${this.state.UI.hideGlobalChat ? "d-none" : ""
                      }`}
                    title="publicChat"
                  ></iframe>
                  <div
                    className={`blocker ${this.state.UI.hideGlobalChat ? "d-none" : ""
                      } ${this.state.UI.fadeIntroImage ? "d-none" : ""}`}
                    style={{ zIndex: "-1" }}
                  >
                    <div
                      className={`lds-dual-ring ${this.state.UI.hideGlobalChat ? "d-none" : ""
                        }`}
                    ></div>
                  </div>
                </div>
              )}
            {
              <footer className={`footerBox ${isIOS ? "footer-ios" : ""}`}>
                {this.state.UI.overlayMenu && (
                  <>
                    {this.state.UI.overlayMenu.id === menuItemsId.MyProfile && (
                      <div>
                        <MyProfile
                          mute={this.state.mute}
                          activeMenu={this.state.UI.activeMenu}
                          close={this.hideOverlayMenu}
                          ShowMediaModal={this.handleMedialModalFromOverlay}
                        ></MyProfile>
                      </div>
                    )}
                  </>
                )}
                {this.state.UI.activeMenu &&
                  !this.state.UI.activeMenu.subMenus && (
                    <Menu
                      items={this.state.UI.menuItems}
                      activeItemId={
                        this.state.UI.overlayMenu
                          ? this.state.UI.overlayMenu.id
                          : this.state.UI.activeMenu.id
                      }
                      onMenuItemClick={this.handleClick}
                      canInteract={this.state.UI.isInteractable}
                    ></Menu>
                  )}
                {this.state.UI.activeMenu.subMenus && (
                  <Menu
                    items={this.state.UI.activeMenu.subMenus}
                    activeItemId={
                      this.state.UI.activeSubMenu
                        ? this.state.UI.activeSubMenu.id
                        : -1
                    }
                    onMenuItemClick={this.handleSubmenuItemClick}
                    canInteract={true}
                    backButton={true}
                    onBackButtonClick={(e) => {
                      if (
                        this.state.UI.activeMenu.id === menuItemsId.Lobby ||
                        this.state.UI.activeMenu.id === menuItemsId.Game
                      ) {
                        this.handleClick(
                          e,
                          menuItems[menuItemsIndex.Prelobby],
                          false
                        );
                      }
                    }}
                  ></Menu>
                )}
                {this.state.UI.activeSubMenu &&
                  (this.state.UI.activeMenu.id === menuItemsId.Audi ||
                    this.state.UI.activeMenu.id === menuItemsId.bdr) && (
                    <>
                      {this.state.UI.activeSubMenu.id === SubMenuId.QNA && (
                        <div className={`submenu-container active expended`}>
                          <QNA
                            headerName={"Q&A"}
                            onHeadingClick={this.closeSubMenu}
                            QNACollection={"qna-dbr"}
                            QNAReplyCollection={"qnaReply-dbr"}
                            canReply={false}
                            moderated={false}
                          ></QNA>
                        </div>
                      )}
                      {this.state.UI.activeSubMenu.id === SubMenuId.POll && (
                        <div className={`submenu-container active expended`}>
                          <PublicPoll
                            onHeadingClick={this.closeSubMenu}
                            PollAdmin_Col={"pollAdmin"}
                            PollAdmin_Doc={"adminAccess"}
                            Poll_Doc={"poll-dbr"}
                          ></PublicPoll>
                        </div>
                      )}
                    </>
                  )}
              </footer>
            }
          </section>
        </div>
        {isIOS ? this.state.mute ? <></> :
          <>
            {this.state.playCurrentAudio &&
              this.checkIfAudioCanPlayUnderMediaModal() &&
              this.state.UI.activeMenu.id !== menuItemsId.Game &&
              !this.state.showMemoryLane &&
              !this.state.showIntro &&
              !this.state.instructionVideo &&
              !this.state.funzone && (
                <ReactAudioPlayer
                  src="/3dAssets/music/ambientMusic.mp3"
                  autoPlay
                  volume={this.state.mute ? 0 : 0.04}
                  loop={true}
                  preload="auto"
                  ref={this.currentAudioRef}
                />
              )}
          </> :
          <>
            {this.state.playCurrentAudio &&
              this.checkIfAudioCanPlayUnderMediaModal() &&
              this.state.UI.activeMenu.id !== menuItemsId.Game &&
              !this.state.showMemoryLane &&
              !this.state.showIntro &&
              !this.state.instructionVideo &&
              !this.state.funzone && (
                <ReactAudioPlayer
                  src="/3dAssets/music/ambientMusic.mp3"
                  autoPlay
                  volume={this.state.mute ? 0 : 0.04}
                  loop={true}
                  preload="auto"
                  ref={this.currentAudioRef}
                />
              )}
          </>
        }
        <ReactAudioPlayer
          src={coinSound}
          autoPlay={false}
          volume={this.state.mute ? 0.5 : 0.5}
          loop={false}
          preload="auto"
          ref={this.coinsound}
          onEnded={() => {
            this.coinsound.current.audioEl.current.load();
          }}
        />
        {this.state.showRotate && (
          <div id="rotate">
            <div className="phone"> </div>
            <div className="message">Please rotate your device! </div>
          </div>
        )}
      </>
    );
  }
}
Home2.contextType = UserContext;

export default Home2;
